import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {FinishChildcareFlow} from 'pages/withAuth/mypage/procedures/finishChildcare/flow'

export const FinishChildcareRoutes: RouteParams[] = [
  {
    key: '/mypage/finish_childcare/flow/:id',
    path: MYPAGE_PATHS.PROCEDURES.FINISH_CHILDCARE.FLOW,
    component: FinishChildcareFlow,
    exact: true,
  },
]
